<template>
  <div class="row">
    <div class="col-md-12" style="margin: -15px; font-size: small;">
      <div class="card card-sm">
        <div class="card-header" style="background-color: #DBECDB;">
          <h5 class="card-title">Gestión de Partidas</h5>
          <div class="row mb-3">
            <div class="col-md-8">
              <div class="form-group">
                <div class="input-group">
                  <input
                    type="text"
                    v-model="filters.search"
                    class="form-control"
                    placeholder="Buscar por código, nombre o descripción..."
                    @keyup.enter="handleSearch"
                  />
                  <button
                    class="btn btn-outline-secondary"
                    type="button"
                    @click="handleSearch"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <BButton
                v-if="hasPermission('param_create')"
                @click="showModal(null)"
                variant="primary"
                class="btn-round me-2"
              >
                <i class="fa fa-plus me-1"></i> Nueva Partida
              </BButton>
              <BButton
                v-if="hasPermission('param_create')"
                variant="danger"
                class="btn-round"
                @click="generatePDF"
              >
                <i class="fa fa-file-pdf me-1"></i> PDF
              </BButton>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div v-if="loading" class="text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
          </div>

          <div v-else>
            <div class="table-responsive">
              <table class="table table-sm table-striped table-hover table-bordered">
                <thead class="text-primary">
                  <tr style="line-height: 8px; font-size: 0.8rem;">
                    <th>Código</th>
                    <th>Nombre</th>
                    <th>Padre</th>
                    <th>Nivel</th>
                    <th>Ramas</th>
                    <th>Clase</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="partida in partidas" :key="partida.codigo">
                    <td>{{ partida.codigo }}</td>
                    <td>{{ partida.nombre }}</td>
                    <td>{{ partida.padre }}</td>
                    <td>{{ partida.nivel }}</td>
                    <td>{{ partida.ramas }}</td>
                    <td>{{ partida.descripcionClase }}</td>
                    <td>
                      <div class="btn-group">
                        <BButton
                          v-if="hasPermission('param_update')"
                          @click="showModal(partida)"
                          variant="warning"
                          size="sm"
                          class="me-1"
                        >
                          <i class="fa fa-edit"></i>
                        </BButton>
                        <BButton
                          v-if="hasPermission('param_delete')"
                          @click="confirmDelete(partida)"
                          variant="danger"
                          size="sm"
                        >
                          <i class="fa fa-trash"></i>
                        </BButton>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Paginación -->
            <div class="row mt-3" v-if="pagination.total > 0">
              <div class="col-md-12">
                <BPagination
                v-model="pagination.current_page"
                :total-rows="pagination.total"
                :per-page="pagination.per_page"
                @update:modelValue="handlePageChange"
                align="center"
              ></BPagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para crear/editar -->
    <BModal
      v-model="modalVisible"
      :title="modalTitle"
      size="lg"
      centered
      hide-footer
      no-close-on-backdrop
    >
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-label">Código</label>
              <input
                type="text"
                v-model="form.codigo"
                class="form-control"
                :class="{ 'is-invalid': errors.codigo }"
                required
                :disabled="isEditing"
              />
              <div class="invalid-feedback" v-if="errors.codigo">
                {{ errors.codigo[0] }}
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-label">Código Padre</label>
              <input
                type="text"
                v-model="form.padre"
                class="form-control"
                :class="{ 'is-invalid': errors.padre }"
                required
              />
              <div class="invalid-feedback" v-if="errors.padre">
                {{ errors.padre[0] }}
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-label">Nivel</label>
              <input
                type="number"
                v-model="form.nivel"
                class="form-control"
                :class="{ 'is-invalid': errors.nivel }"
                required
              />
              <div class="invalid-feedback" v-if="errors.nivel">
                {{ errors.nivel[0] }}
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-label">Ramas</label>
              <input
                type="number"
                v-model="form.ramas"
                class="form-control"
                :class="{ 'is-invalid': errors.ramas }"
                required
              />
              <div class="invalid-feedback" v-if="errors.ramas">
                {{ errors.ramas[0] }}
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-label">Clase</label>
              <input
                type="number"
                v-model="form.clase"
                class="form-control"
                :class="{ 'is-invalid': errors.clase }"
              />
              <div class="invalid-feedback" v-if="errors.clase">
                {{ errors.clase[0] }}
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-label">Descripción Clase</label>
              <input
                type="text"
                v-model="form.descripcionClase"
                class="form-control"
                :class="{ 'is-invalid': errors.descripcionClase }"
                maxlength="35"
              />
              <div class="invalid-feedback" v-if="errors.descripcionClase">
                {{ errors.descripcionClase[0] }}
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-12">
            <div class="form-group">
              <label class="form-label">Nombre</label>
              <input
                type="text"
                v-model="form.nombre"
                class="form-control"
                :class="{ 'is-invalid': errors.nombre }"
                required
                maxlength="500"
              />
              <div class="invalid-feedback" v-if="errors.nombre">
                {{ errors.nombre[0] }}
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-12">
            <div class="form-group">
              <label class="form-label">Descripción</label>
              <textarea
                v-model="form.descripcion"
                class="form-control"
                :class="{ 'is-invalid': errors.descripcion }"
                rows="3"
              ></textarea>
              <div class="invalid-feedback" v-if="errors.descripcion">
                {{ errors.descripcion[0] }}
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer mt-3">
          <BButton
            type="button"
            variant="secondary"
            @click="modalVisible = false"
            class="me-2"
          >
            Cancelar
          </BButton>
          <BButton
            type="submit"
            variant="primary"
            :disabled="loadingForm"
          >
            <span v-if="loadingForm" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ isEditing ? 'Actualizar' : 'Guardar' }}
          </BButton>
        </div>
      </form>
    </BModal>
  </div>
</template>

<script lang="ts">
import { ref, onMounted, computed } from 'vue';
import axios from 'axios';
import { useAuthStore } from '../../stores/authStore';
import Swal from 'sweetalert2';
import { BModal, BButton, BPagination } from 'bootstrap-vue-3';

interface Partida {
  codigo: string;
  padre: string;
  nivel: number;
  ramas: number;
  nombre: string;
  descripcion: string | null;
  clase: number | null;
  descripcionClase: string | null;
}

interface Filters {
  search: string;
}

interface FormData {
  codigo: string;
  padre: string;
  nivel: number;
  ramas: number;
  nombre: string;
  descripcion: string;
  clase: number | null;
  descripcionClase: string | null;
}

interface Pagination {
  current_page: number;
  per_page: number;
  total: number;
  last_page: number;
}

export default {
  components: {
    BModal,
    BButton,
    BPagination
  },
  setup() {
    const partidas = ref<Partida[]>([]);
    const loading = ref(true);
    const authStore = useAuthStore();
    const filters = ref<Filters>({
      search: ''
    });

    // Variables para el modal
    const modalVisible = ref(false);
    const isEditing = ref(false);
    const loadingForm = ref(false);
    const errors = ref<Record<string, string[]>>({});

    const form = ref<FormData>({
      codigo: '',
      padre: '',
      nivel: 1,
      ramas: 0,
      nombre: '',
      descripcion: '',
      clase: null,
      descripcionClase: null
    });

    // Paginación
    const pagination = ref<Pagination>({
      current_page: 1,
      per_page: 10,
      total: 0,
      last_page: 1
    });

    const modalTitle = computed(() => {
      return isEditing.value ? 'Editar Partida' : 'Nueva Partida';
    });

    const showModal = (partida: Partida | null) => {
      errors.value = {};
      if (partida) {
        // Edición
        isEditing.value = true;
        form.value = {
          codigo: partida.codigo,
          padre: partida.padre,
          nivel: partida.nivel,
          ramas: partida.ramas,
          nombre: partida.nombre,
          descripcion: partida.descripcion || '',
          clase: partida.clase,
          descripcionClase: partida.descripcionClase
        };
      } else {
        // Nuevo
        isEditing.value = false;
        form.value = {
          codigo: '',
          padre: '',
          nivel: 1,
          ramas: 0,
          nombre: '',
          descripcion: '',
          clase: null,
          descripcionClase: null
        };
      }
      modalVisible.value = true;
    };

    const handleSubmit = async () => {
      loadingForm.value = true;
      errors.value = {};

      try {
        let response;

        if (isEditing.value) {
          response = await axios.post(`/partida/${form.value.codigo}/update`, form.value);
        } else {
          response = await axios.post('/partida/save', form.value);
        }

        Swal.fire({
          icon: 'success',
          title: 'Éxito',
          text: isEditing.value ? 'Partida actualizada correctamente' : 'Partida creada correctamente'
        });

        modalVisible.value = false;
        fetchPartidas();
      } catch (error: any) {
        if (error.response && error.response.status === 422) {
          errors.value = error.response.data.errors;
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.response?.data?.message || 'Ocurrió un error al procesar la solicitud'
          });
        }
      } finally {
        loadingForm.value = false;
      }
    };

    const fetchPartidas = async () => {
      loading.value = true;
      try {
        const params: Record<string, any> = {
          page: pagination.value.current_page,
          per_page: pagination.value.per_page
        };

        if (filters.value.search) {
          params.search = filters.value.search;
        }

        const response = await axios.get('/partida/list', { params });
        partidas.value = response.data.partidas.data;

        // Actualizar paginación
        pagination.value = {
          current_page: response.data.partidas.current_page,
          per_page: response.data.partidas.per_page,
          total: response.data.partidas.total,
          last_page: response.data.partidas.last_page
        };

      } catch (error) {
        console.error('Error al cargar partidas:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar las partidas'
        });
      } finally {
        loading.value = false;
      }
    };

    const handleSearch = () => {
      pagination.value.current_page = 1;
      fetchPartidas();
    };

    const handlePageChange = (page: number) => {
      console.log('Cambiando a página:', page);
      pagination.value.current_page = page;
      fetchPartidas();
    };

    const confirmDelete = (partida: Partida) => {
      Swal.fire({
        title: '¿Está seguro?',
        text: `¿Desea eliminar la partida ${partida.nombre}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          deletePartida(partida.codigo);
        }
      });
    };

    const deletePartida = async (codigo: string) => {
      try {
        await axios.get(`/partida/${codigo}/delete`);
        Swal.fire({
          icon: 'success',
          title: 'Partida eliminada',
          text: 'La partida ha sido eliminada correctamente'
        });
        await fetchPartidas();
      } catch (error: any) {
        console.error('Error al eliminar partida:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'No se pudo eliminar la partida'
        });
      }
    };

    const generatePDF = () => {
      const params = filters.value.search ? { search: filters.value.search } : {};

      axios.get('/partida/reporte', {
        params,
        responseType: 'blob',
        headers: {
          'Accept': 'application/pdf'
        }
      }).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `reporte_partidas.pdf`);
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);
      }).catch(error => {
        console.error('Error al generar PDF:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo generar el PDF'
        });
      });
    };

    const hasPermission = (permission: string) => {
      return authStore.hasPermission(permission);
    };

    onMounted(() => {
      fetchPartidas();
    });

    return {
      partidas,
      filters,
      loading,
      form,
      errors,
      loadingForm,
      isEditing,
      modalTitle,
      modalVisible,
      pagination,
      handleSearch,
      handlePageChange,
      confirmDelete,
      hasPermission,
      showModal,
      handleSubmit,
      generatePDF
    };
  }
};
</script>

<style scoped>
  thead th {
    background-color: #D84315;
    color:#ffffff;
    position: sticky;
    top: 0;
  }
  tbody td {
    margin: 0px;
    padding: 8px !important;
    vertical-align: middle;
  }
  .table-responsive {
    max-height: 600px;
    overflow-y: auto;
  }
  .btn-round {
    border-radius: 50px;
  }
</style>
